import type { ChartZone } from './chartGeometry';

export interface ChartActivityInput {
  id: string;
  baseline: number | null;
  value: number | null;
  zone: ChartZone;
  enabled: boolean;
}
export interface ChartActivity extends ChartActivityInput {
  lastZone: ChartZone;
  quote: number;
  crossing: number;
}

// Decorative events follow new evidence and the drawn endpoint, never a clock.
export function chartActivity(
  previous: ChartActivity | null,
  input: ChartActivityInput,
): ChartActivity {
  if (
    previous &&
    previous.id === input.id &&
    Object.is(previous.baseline, input.baseline) &&
    Object.is(previous.value, input.value) &&
    previous.zone === input.zone &&
    previous.enabled === input.enabled
  )
    return previous;

  if (
    !previous ||
    previous.id !== input.id ||
    previous.baseline !== input.baseline ||
    !previous.enabled ||
    !input.enabled
  )
    return { ...input, lastZone: input.zone, quote: 0, crossing: 0 };

  const crossed =
    input.zone !== 'neutral' &&
    previous.lastZone !== 'neutral' &&
    input.zone !== previous.lastZone;
  return {
    ...input,
    lastZone: input.zone === 'neutral' ? previous.lastZone : input.zone,
    quote: previous.quote + Number(input.value !== previous.value),
    crossing: previous.crossing + Number(crossed),
  };
}
